export default __webpack_public_path__ + "static/media/pnb.01cfb350.png";